/**
 * Browser client for the app's own backend (/api/*). All NoCodeBackend access
 * happens server-side; the browser only ever holds a session cookie.
 */
export class ApiError extends Error {
  constructor(message, status, code) {
    super(message);
    this.status = status;
    this.code = code;
  }
}

async function request(url, options = {}) {
  const res = await fetch(url, { credentials: 'include', ...options });
  const text = await res.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    /* non-JSON body */
  }
  if (!res.ok) {
    throw new ApiError(data?.error || data?.message || `Request failed (${res.status})`, res.status, data?.code);
  }
  return data;
}

/** Call a data action, e.g. api('searchParts', { query }). */
export const api = (action, args = {}) =>
  request('/api/data', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ action, ...args }),
  });

/** Call a Better Auth endpoint through the auth proxy, e.g. auth('sign-in/email', { email, password }). */
export const auth = (path, body) =>
  request(`/api/auth/${path}`, {
    method: body === undefined ? 'GET' : 'POST',
    headers: body === undefined ? undefined : { 'Content-Type': 'application/json' },
    body: body === undefined ? undefined : JSON.stringify(body),
  });

export const getProviders = () => request('/api/auth-providers');
